import { combineReducers } from 'redux';
import user from './user_reducer';
import orderTrans from './order_transaction_history_reducer';
import order from './order_history_reducer';
import setting from './setting_data_reducer';
import setting_fee_transaction from './setting_fee_transaction_reducer';
import transaction_fee from './transaction_fee_reducer';
import transaction from './transaction_reducer';
import login from './login_reducer';
import admin from './admin_reducer';
import tools from './tools_reducer';
import statistic from './statistic_reducer';
import role from './role_reducer';
import authorization from './authorization_reducer';
import affiliate from './affiliate_reducer';
import campaign from './campaign_reducer';
import admin_wallets from './admin_wallet_reducer';
import notification from './notification_reducer';
import commission from './commission_reducer';
import prize from './prize_reducer';
import favorite from './favorite_reducer';
import init from './init_reducer';

const allReducers = combineReducers({
  user,
  orderTrans,
  setting,
  setting_fee_transaction,
  transaction_fee,
  transaction,
  order,
  login,
  admin,
  tools,
  statistic,
  role,
  authorization,
  affiliate,
  campaign,
  admin_wallets,
  notification,
  commission,
  prize,
  favorite,
  init,
});

export default allReducers;
